import * as React from 'react';
import './WarrantyView.scss';
import Breadcrumbs from 'src/components/common/Breadcrumbs';
import i18n from 'src/translation/i18n';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { damagedPartsUrl, defectivePartsUrl } from 'src/utils/navigation';
import WarrantyClaim from '../WarrantyClaim/WarrantyClaim';
import ProductWarranty from '../ProductWarranty/ProductWarranty';
import DamagedView from '../DamagedView';
import { withI18n } from 'react-i18next';
import DifferentissueView from '../DifferentissueView/DifferentissueView';
import damageupon from '../../assets/damageupon';
import partfailed from '../../assets/partfailedIcon';
import scotmanClaimIcon from '../../assets/scotmanClaimIcon';
import issuewithorder from '../../assets/issuewithorderIcon';
import { makeStyles } from '@material-ui/core/styles';
import CSStatus from 'src/components/ClaimStatus/components/CSStatus/CSStatus';
import ClaimStatusModel from 'src/model/ClaimStatus.model';

import iObjCSService from 'src/services/claimStatus/claimStatusService';
import ClaimDetailsModel from 'src/model/ClaimDetails.model';
import ClaimPartDetails from 'src/model/ClaimPartDetails.model';
import env from 'src/shared/env';
import Button from 'src/components/common/Button';
import PackageNeverArrived from '../PackageNeverArrived';
import OrderMissingPart from '../OrderMissingPart';
import OrderExtraPart from '../OrderExtraPart';
import ReceivedUsedPartPart from '../ReceivedUsedPart';
import WrongPartShipped from '../WrongPartShipped';
import { goToReturns } from 'src/utils/navigation';
import packageNeverArrivedIcon from '../../assets/packageNeverArrivedIcon';
import orderMissingPartIcon from '../../assets/orderMissingPartIcon';
import wrongPartWasOrderedIcon from '../../assets/wrongPartWasOrderedIcon';
import wrongPartShippedIcon from '../../assets/wrongPartShippedIcon';
import usedPartIcon from '../../assets/usedPartIcon';
import extraPartIcon from '../../assets/extraPartIcon';
interface IWarrantyProps {
  t?: any;
  // currentTab: number;
  // selectTab: (index: number) => void;
}

const WarrantyView: React.FC<IWarrantyProps> = props => {
  const [apiLoader, handleApiLoader] = React.useState(false);

  const {
    t
    // currentTab,
    // selectTab,
  } = props;
  const useStyles = makeStyles({
    label: {
      // backgroundColor: '#aa0',
      fontSize: '40px'
    },

    wcsLabel: {
      fontWeight: 'normal'
    }
  });
  const classes = useStyles();

  const [currentTab, setCurrentTab] = React.useState<number>(0);
  const [value, setValue] = React.useState(0);
  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
    backToClaimDashboard();
    if (cResubmitDetails || RSClaimDetails) {
      setActive(false);
      setThirdActive(false);
      setSecondActive(false);
      setcResubmitDetails(null);
      SetRSClaimDetails(null);
    }
  };
  const [active, setActive] = React.useState(false);
  const [secondactive, setSecondActive] = React.useState(false);
  const [thirdactive, setThirdActive] = React.useState(false);
  const [fourthactive, setFourthActive] = React.useState(false);
  const [packageNeverArrivedActive, setPackageNeverArrivedActive] = React.useState(false);
  const [orderMissingPartActive, setOrderMissingPartActive] = React.useState(false);
  const [wrongPartShippedActive, setWrongPartShippedActive] = React.useState(false);
  const [receivedUsedPartActive, setReceivedUsedPartActive] = React.useState(false);
  const [orderedExtraPartActive, setOrderedExtraPartActive] = React.useState(false);
  const [wrongPartOrderedActive, setWrongPartOrderedActive] = React.useState(false);
  const [selectedClaimTypeName, setSelectedClaimTypeName] = React.useState('');
  const [selectedClaimTypeHeadingTitle, setSelectedClaimTypeHeadingTitle] = React.useState('');
  const [selectedClaimType, setSelectedClaimType] = React.useState('');
  const firstcard = () => {
    /* if(bStatus && bStatus===true){
      setcResubmitDetails(null);
      SetResubmitClaim(false);
    } */

    // debugger;
    if (
      !cResubmitDetails ||
      (cResubmitDetails &&
        cResubmitDetails.claimType.toLowerCase().substring(0, 5) === 'faile')
    ) {
      setSecondActive(false);
      setThirdActive(false);
      setFourthActive(false);
      setPackageNeverArrivedActive(false);
      setOrderMissingPartActive(false);
      setWrongPartOrderedActive(false);
      setWrongPartShippedActive(false);
      setReceivedUsedPartActive(false);
      setOrderedExtraPartActive(false);
      setActive(true);
      setSelectedClaimTypeName("PART_FAILED_AFETR_INSTALL");
      setSelectedClaimTypeHeadingTitle("Part Failed After Install");
    }
  };
  const secondcard = () => {
    /* if(bStatus && bStatus===true){
      setcResubmitDetails(null);
      SetResubmitClaim(false);
    } */
    // debugger;
    if (
      !cResubmitDetails ||
      (cResubmitDetails &&
        cResubmitDetails.claimType.toLowerCase().substring(0, 5) === 'damag')
    ) {
      setActive(false);
      setThirdActive(false);
      setFourthActive(false);
      setPackageNeverArrivedActive(false);
      setOrderMissingPartActive(false);
      setWrongPartOrderedActive(false);
      setWrongPartShippedActive(false);
      setReceivedUsedPartActive(false);
      setOrderedExtraPartActive(false);
      setSecondActive(true);
      setSelectedClaimTypeName("DAMAGED_UPON_ARRIVAL");
      setSelectedClaimTypeHeadingTitle("Damage Upon Arrival");
      setSelectedClaimType("damageUponArrival");
    }
  };
  const thirdcard = () => {
    if (cResubmitDetails === undefined) {
      setActive(false);
      setSecondActive(false);
      setFourthActive(false);
      setThirdActive(true);
    }
  };

  const fourthcard = () => {
    /* if(bStatus && bStatus===true){
      setcResubmitDetails(null);
      SetResubmitClaim(false);
    } */

    // debugger;

    if (
      !cResubmitDetails ||
      (cResubmitDetails &&
        cResubmitDetails.claimType.toLowerCase() === 'product warranty')
    ) {
      setActive(false);
      setSecondActive(false);
      setThirdActive(false);
      setPackageNeverArrivedActive(false);
      setOrderMissingPartActive(false);
      setWrongPartOrderedActive(false);
      setWrongPartShippedActive(false);
      setReceivedUsedPartActive(false);
      setOrderedExtraPartActive(false);
      setFourthActive(true);
      setSelectedClaimTypeName("SCOTMAN_WARRANTY");
      setSelectedClaimTypeHeadingTitle("Product Warranty (Scotman Only)");
      setSelectedClaimType("productWarrantyScotman");
    }
  };

  const packageNeverArrived = () => {
    if (
      !cResubmitDetails ||
      (cResubmitDetails &&
        cResubmitDetails.claimType.toLowerCase().substring(0, 7) === 'package')
    ) {
      setActive(false);
      setSecondActive(false);
      setThirdActive(false);
      setFourthActive(false);
      setPackageNeverArrivedActive(true);
      setOrderMissingPartActive(false);
      setWrongPartOrderedActive(false);
      setWrongPartShippedActive(false);
      setReceivedUsedPartActive(false);
      setOrderedExtraPartActive(false);
      setSelectedClaimTypeName("PACKAGE_NEVER_ARRIVED");
      setSelectedClaimTypeHeadingTitle("Package Never Arrived");
      setSelectedClaimType("packageNeverArrived");
    }
  }
  const orderIsMissingPart = () => {
    if (
      !cResubmitDetails ||
      (cResubmitDetails &&
        cResubmitDetails.claimType.toLowerCase().substring(0, 7) === 'order i')
    ) {
      setActive(false);
      setSecondActive(false);
      setThirdActive(false);
      setFourthActive(false);
      setPackageNeverArrivedActive(false);
      setOrderMissingPartActive(true);
      setWrongPartOrderedActive(false);
      setWrongPartShippedActive(false);
      setReceivedUsedPartActive(false);
      setOrderedExtraPartActive(false);
      setSelectedClaimTypeName("ORDER_MISSING_PART");
      setSelectedClaimTypeHeadingTitle("Order is Missing Part");
      setSelectedClaimType("orderMissingPart");
    }
  }
  const wrongPartWaShipped = () => {
    if (
      !cResubmitDetails ||
      (cResubmitDetails &&
        cResubmitDetails.claimType.toLowerCase().substring(0, 7) === 'wrongpa')
    ) {
      setActive(false);
      setSecondActive(false);
      setThirdActive(false);
      setFourthActive(false);
      setPackageNeverArrivedActive(false);
      setOrderMissingPartActive(false);
      setWrongPartOrderedActive(false);
      setWrongPartShippedActive(true);
      setReceivedUsedPartActive(false);
      setOrderedExtraPartActive(false);
      setSelectedClaimTypeName("WRONG_PART_SHIPPED");
      setSelectedClaimTypeHeadingTitle("Wrong Part was Shipped");
      setSelectedClaimType("wrongPartShipped");
    }
  }
  const receivedUsedPart = () => {
    if (
      !cResubmitDetails ||
      (cResubmitDetails &&
        cResubmitDetails.claimType.toLowerCase().substring(0, 7) === 'receive')
    ) {
      setActive(false);
      setSecondActive(false);
      setThirdActive(false);
      setFourthActive(false);
      setPackageNeverArrivedActive(false);
      setOrderMissingPartActive(false);
      setWrongPartOrderedActive(false);
      setWrongPartShippedActive(false);
      setReceivedUsedPartActive(true);
      setOrderedExtraPartActive(false);
      setSelectedClaimTypeName("RECEIVED_USED_PART");
      setSelectedClaimTypeHeadingTitle("Received Used Part");
      setSelectedClaimType("receivedUsedPart");
    }
  }
  const orderHasExtraPart = () => {
    if (
      !cResubmitDetails ||
      (cResubmitDetails &&
        cResubmitDetails.claimType.toLowerCase().substring(0, 7) === 'order h')
    ) {
      setActive(false);
      setSecondActive(false);
      setThirdActive(false);
      setFourthActive(false);
      setPackageNeverArrivedActive(false);
      setOrderMissingPartActive(false);
      setWrongPartOrderedActive(false);
      setWrongPartShippedActive(false);
      setReceivedUsedPartActive(false);
      setOrderedExtraPartActive(true);
      setSelectedClaimTypeName("ORDER_EXTRA_PART");
      setSelectedClaimTypeHeadingTitle("Order Extra Part");
      setSelectedClaimType("orderExtraPart");
    }
  }
  const wrongPartWaOrdered =() =>{
    goToReturns();
  }

  const backToClaimDashboard=()=>{
    setSelectedClaimTypeName("");
    setSelectedClaimTypeHeadingTitle("");
    setActive(false);
    setSecondActive(false);
    setThirdActive(false);
    setFourthActive(false);
    setPackageNeverArrivedActive(false);
    setOrderMissingPartActive(false);
    setWrongPartOrderedActive(false);
    setWrongPartShippedActive(false);
    setReceivedUsedPartActive(false);
    setOrderedExtraPartActive(false)
  }

  const backToClaimDashboardFromMobile=()=>{
    setSelectedClaimTypeName("");
    setSelectedClaimTypeHeadingTitle("");
    setActive(false);
    setSecondActive(false);
    setThirdActive(false);
    setFourthActive(false);
    setPackageNeverArrivedActive(false);
    setOrderMissingPartActive(false);
    setWrongPartOrderedActive(false);
    setWrongPartShippedActive(false);
    setReceivedUsedPartActive(false);
    setOrderedExtraPartActive(false)
  }


  const [reset, checkReset] = React.useState(false);
  const [cardActive, SetCardActiveStatus] = React.useState(false);

  const [IsRClaim, SetResubmitClaim] = React.useState(false);

  const [cResubmitDetails, setcResubmitDetails] = React.useState<
    ClaimPartDetails
  >();
  const [RSClaimDetails, SetRSClaimDetails] = React.useState<any>();
  function GetCSPDetails() {
    const activeAccount = localStorage.getItem('activeAccount');
    handleApiLoader(true);
    iObjCSService
      .getCSPartDetails(activeAccount, cResubmitDetails)
      .then((response: any) => {
        // console.log(response.data);
        const resData = response.data;
        if (cResubmitDetails.claimType.substring(0, 5) === 'Damag') {
          SetRSClaimDetails(resData);
        } else if (cResubmitDetails.claimType.substring(0, 5) === 'Faile') {
          SetRSClaimDetails(resData);
        }

        // console.log(RSClaimDetails);
        handleApiLoader(false);
      })
      .catch((error: any) => {
        // console.log(error);
        handleApiLoader(false);
        // removeColumnOrganiser();
      });
  }

  function GetCSPDetailsProductWarranty() {
    const activeAccount = localStorage.getItem('activeAccount');
    handleApiLoader(true);
    iObjCSService
      .getCSPartDetailsProductWarranty(activeAccount, cResubmitDetails)
      .then((response: any) => {
        // console.log(response.data);
        const resData = response.data;
       if (cResubmitDetails.claimType.toLowerCase() === 'product warranty') {
          SetRSClaimDetails(resData);
        }

        // console.log(RSClaimDetails);
        handleApiLoader(false);
      })
      .catch((error: any) => {
        // console.log(error);
        handleApiLoader(false);
        // removeColumnOrganiser();
      });
  }

  React.useEffect(() => {
    if (IsRClaim) {
       console.log("===== Resubmit Details =======",cResubmitDetails.claimType.toLowerCase().substring(0, 7));
      // debugger;
      if (cResubmitDetails && cResubmitDetails.claimType.toLowerCase().substring(0, 7) === 'failed') {
        firstcard();
        GetCSPDetails();
      } else if (cResubmitDetails && cResubmitDetails.claimType.toLowerCase().substring(0, 7) === 'damaged') {
        secondcard();
        GetCSPDetails();
      }else if(cResubmitDetails && cResubmitDetails.claimType.toLowerCase().substring(0, 7) === 'product'){
          fourthcard();
          GetCSPDetailsProductWarranty();
      }else if (cResubmitDetails && cResubmitDetails.claimType.toLowerCase().substring(0, 7) === 'package') {
        packageNeverArrived();
        GetCSPDetails();
      }else if (cResubmitDetails && cResubmitDetails.claimType.toLowerCase().substring(0, 7) === 'order i') {
        orderIsMissingPart();
        GetCSPDetails();
      }else if (cResubmitDetails && cResubmitDetails.claimType.toLowerCase().substring(0, 7) === 'wrongpa') {
        wrongPartWaShipped();
        GetCSPDetails();
      }else if (cResubmitDetails && cResubmitDetails.claimType.toLowerCase().substring(0, 7) === 'receive') {
        receivedUsedPart();
        GetCSPDetails();
      }else if (cResubmitDetails && cResubmitDetails.claimType.toLowerCase().substring(0, 7) === 'order h') {
        orderHasExtraPart();
        GetCSPDetails();
      }
      setValue(0);
      SetResubmitClaim(false);
    }
  }, [IsRClaim]);

  return (
    <div className="warranty-view">
      <h3>{i18n.t('warrantyView.myclaims')}</h3>
      <Tabs
        value={value}
        indicatorColor="primary"
        onChange={handleChange}
        aria-label="disabled tabs example"
        className={classes.label}
      >
        <Tab
          label={i18n.t('warrantyView.submitClaim')}
          style={{
            textTransform: 'none',
            fontFamily: 'Roboto',
            letterSpacing: 'inherit'
          }}
        />
        <Tab
          label={i18n.t('warrantyView.claimStatus')}
          style={{
            textTransform: 'none',
            fontFamily: 'Roboto',
            letterSpacing: 'inherit',
            marginLeft: '10px'
          }}
          className={classes.wcsLabel}
        />
      </Tabs>
      {apiLoader ? (
        <div className="loader-container">
          <div className="loader" />
        </div>
      ) : (
        <>
          {value === 0 && (
            <>
              <div className="tab-set-container">
              {selectedClaimTypeName ?(
                    <div className="warranty-view-title-row">
                    <div>
                      <p className="claim-type">
                      {selectedClaimTypeHeadingTitle}
                      </p>
                    </div>
                    <div>
                      <Button
                            buttonClass="warranty-view-btn"
                            label={i18n.t('warrantyView.backToDashboard')}
                            textTransform="uppercase"
                            action={backToClaimDashboard}
                          />
                    </div>
                    </div>
                ):(
                  <p className="claim-type">
                  {i18n.t('warrantyView.selectissue')}
                   </p>
                )}
                 {!selectedClaimTypeName ?(
                <div className="d-flex card-wrapper">
                   {/* Part Failed after Install */}
                  <div className="invoice-card-container">
                    <div className="tick-holder">
                      {' '}
                      {active === true ? (
                        <i className="rpds rpds-check-circle success " />
                      ) : (
                        ''
                      )}{' '}
                    </div>
                    <div
                      onClick={firstcard}
                      className={`d-flex card-appear ${
                        active === true ? 'border' : ''
                      }`}
                    >
                      <div className="icon-width">
                        <img src={partfailed} alt="partfailed" />
                      </div>

                      <div className="card-info">
                        <div className="total-balance">
                          {i18n.t('warrantyView.partfailed')}
                        </div>
                      </div>
                    </div>
                  </div>

                   {/* Scotman Warranty */}    
                  { env.REACT_APP_BASE_ENVIRONMENT === 'US' &&      
                  <div className="invoice-card-container">
                    <div className="tick-holder">
                      {' '}
                      {fourthactive === true ? (
                        <i className="rpds rpds-check-circle success " />
                      ) : (
                        ''
                      )}{' '}
                    </div>
                    <div
                      onClick={fourthcard}
                      className={`d-flex card-appear ${
                        fourthactive === true ? 'border' : ''
                      }`}
                    >
                      <div className="icon-width">
                        <img src={scotmanClaimIcon} alt="Product Warranty" />
                      </div>

                      <div className="card-info">
                        <div className="total-balance">
                          {i18n.t('warrantyView.productWarranty1')}<br/>
                          {i18n.t('warrantyView.productWarranty2')}
                        </div>
                      </div>
                    </div>
                  </div>
                  }

                   {/* Damaged upon arrival */}
                  <div className="invoice-card-container">
                    <div className="tick-holder">
                      {' '}
                      {secondactive === true ? (
                        <i className="rpds rpds-check-circle success " />
                      ) : (
                        ''
                      )}{' '}
                    </div>
                    <div
                      onClick={secondcard}
                      className={`d-flex card-appear ${
                        secondactive === true ? 'border' : ''
                      }`}
                    >
                      <div className="icon-width">
                        <div className="img-bg3">
                          <img src={damageupon} alt="damageupon" />
                        </div>
                      </div>
                      <div className="card-info">
                        <div className="total-balance">
                          {i18n.t('warrantyView.damageupon')}
                        </div>
                      </div>
                    </div>
                    {/* <div className="enhance-wrapper">
                {secondactive === true ? (
                  <p className="enhancs">(Enhancements Coming Soon!)</p>
                ) : (
                  ''
                )}
              </div> */}
                  </div>

                 {/* Package Never Arrived */}
                 <div className="invoice-card-container">
                    <div className="tick-holder">
                      {' '}
                      {packageNeverArrivedActive === true ? (
                        <i className="rpds rpds-check-circle success " />
                      ) : (
                        ''
                      )}{' '}
                    </div>
                    <div
                      onClick={packageNeverArrived}
                      className={`d-flex card-appear ${
                        packageNeverArrivedActive === true ? 'border' : ''
                      }`}
                    >
                      <div className="icon-width">
                        <img src={packageNeverArrivedIcon} alt="Package Never Arrived"/>
                      </div>

                      <div className="card-info">
                        <div className="total-balance">
                          {i18n.t('warrantyView.packageNeverArrived')}
                        </div>
                      </div>
                    </div>
                  </div>

                       {/* Order is missing part */}
                  <div className="invoice-card-container">
                    <div className="tick-holder">
                      {' '}
                      {orderMissingPartActive === true ? (
                        <i className="rpds rpds-check-circle success " />
                      ) : (
                        ''
                      )}{' '}
                    </div>
                    <div
                      onClick={orderIsMissingPart}
                      className={`d-flex card-appear ${
                        orderMissingPartActive === true ? 'border' : ''
                      }`}
                    >
                      <div className="icon-width">
                        <img src={orderMissingPartIcon} alt="Order Missing Part " style={{width:'40px'}} />
                      </div>

                      <div className="card-info">
                        <div className="total-balance">
                          {i18n.t('warrantyView.orderIsMissingPart')}
                        </div>
                      </div>
                    </div>
                  </div>

                   {/* Wrong part was ordered */}
                   <div className="invoice-card-container">
                    <div
                      onClick={wrongPartWaOrdered}
                      className={`d-flex card-appear ${
                        wrongPartOrderedActive === true ? 'border' : ''
                      }`}
                    >
                      <div className="icon-width">
                        <img src={wrongPartWasOrderedIcon} alt="Wrong Part Was Ordered" />
                      </div>

                      <div className="card-info">
                        <div className="total-balance">
                          {i18n.t('warrantyView.wrongPartOrdered')}
                        </div>
                      </div>
                    </div>
                  </div>

                   {/* Wrong part was shippied */}
                   <div className="invoice-card-container">
                    <div className="tick-holder">
                      {' '}
                      {wrongPartShippedActive === true ? (
                        <i className="rpds rpds-check-circle success " />
                      ) : (
                        ''
                      )}{' '}
                    </div>
                    <div
                      onClick={wrongPartWaShipped}
                      className={`d-flex card-appear ${
                        wrongPartShippedActive === true ? 'border' : ''
                      }`}
                    >
                      <div className="icon-width">
                        <img src={wrongPartShippedIcon} alt="Wrong Part Was Shipped" />
                      </div>

                      <div className="card-info">
                        <div className="total-balance">
                          {i18n.t('warrantyView.wrongPartShippied')}
                        </div>
                      </div>
                    </div>
                  </div>

                   {/* Received a used part */}
                   <div className="invoice-card-container">
                    <div className="tick-holder">
                      {' '}
                      {receivedUsedPartActive === true ? (
                        <i className="rpds rpds-check-circle success " />
                      ) : (
                        ''
                      )}{' '}
                    </div>
                    <div
                      onClick={receivedUsedPart}
                      className={`d-flex card-appear ${
                        receivedUsedPartActive === true ? 'border' : ''
                      }`}
                    >
                      <div className="icon-width">
                        <img src={usedPartIcon} alt="Received Used Part" />
                      </div>

                      <div className="card-info">
                        <div className="total-balance">
                          {i18n.t('warrantyView.receivedUsedPart')}
                        </div>
                      </div>
                    </div>
                  </div>

                   {/* Order has extra part */}
                   <div className="invoice-card-container">
                    <div className="tick-holder">
                      {' '}
                      {orderedExtraPartActive === true ? (
                        <i className="rpds rpds-check-circle success " />
                      ) : (
                        ''
                      )}{' '}
                    </div>
                    <div
                      onClick={orderHasExtraPart}
                      className={`d-flex card-appear ${
                        orderedExtraPartActive === true ? 'border' : ''
                      }`}
                    >
                      <div className="icon-width">
                        <img src={extraPartIcon} alt="Extra Part" />
                      </div>

                      <div className="card-info">
                        <div className="total-balance">
                          {i18n.t('warrantyView.orderExtraPart')}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                 ):(
                <div className="d-flex card-wrapper"> 
                {active ? (
                  <WarrantyClaim
                    t={withI18n()}
                    cResubmitDetails={cResubmitDetails}
                    RSClaimDetails={RSClaimDetails}
                  />
                ): fourthactive ? (
                  <ProductWarranty 
                  t={withI18n()}
                  cResubmitDetails={cResubmitDetails}
                  RSClaimDetails={RSClaimDetails}
                  />
                ) : secondactive ? (
                  <DamagedView
                    cResubmitDetails={cResubmitDetails}
                    RSClaimDetails={RSClaimDetails}
                  />
                ) : thirdactive ? (
                  <DifferentissueView />
                ): packageNeverArrivedActive ? (
                  <PackageNeverArrived
                    cResubmitDetails={cResubmitDetails}
                    RSClaimDetails={RSClaimDetails}
                    backToDashBoard={backToClaimDashboard}
                  />
                ): orderMissingPartActive ? (
                  <OrderMissingPart
                    cResubmitDetails={cResubmitDetails}
                    RSClaimDetails={RSClaimDetails}
                    backToDashBoard={backToClaimDashboard}
                  />
                ): wrongPartShippedActive ? (
                  <WrongPartShipped
                    cResubmitDetails={cResubmitDetails}
                    RSClaimDetails={RSClaimDetails}
                    backToDashBoard={backToClaimDashboard}
                  />
                ): receivedUsedPartActive ? (
                  <ReceivedUsedPartPart
                    cResubmitDetails={cResubmitDetails}
                    RSClaimDetails={RSClaimDetails}
                    backToDashBoard={backToClaimDashboard}
                  />
                ): orderedExtraPartActive ? (
                  <OrderExtraPart
                    cResubmitDetails={cResubmitDetails}
                    RSClaimDetails={RSClaimDetails}
                    backToDashBoard={backToClaimDashboard}
                  />
                ) : (
                  ''
                )}
              </div>
              )}
               </div>
            </>
          )}
          {value === 1 && (
            <>
              <div className="tab-set-container">
                <CSStatus
                  checkReset={checkReset}
                  cResubmitDetails={cResubmitDetails}
                  setcResubmitDetails={setcResubmitDetails}
                  SetResubmitClaim={SetResubmitClaim}
                />
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
};

export default WarrantyView;
